import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { ConnectorViewMappingContext } from './context/context'

const MappingItem = (props) => {
  const { connector, onClick } = props
  let connectorTitle, markedAs

  const [connVwMpState, dispatch] = useContext(ConnectorViewMappingContext)

  connectorTitle = (
    <span>
      <div>{connector.name}</div>
      <div className="font-normal">{connector.description}</div>
      {connector.auto_mapped !== null ? (
        <>
          <div className="font-normal">
            3D Reference:&nbsp;
            {connector.svg_group_reference
              ? connector.svg_group_reference
              : '-'}
          </div>
          {connector.auto_mapped ? (
            <div className={`font-normal`}>
              SVG Object:&nbsp;
              <span
                className={`${connVwMpState.selected_svg_object == connector.auto_mapped && 'text-red-600'}`}
                id={`auto-mapped-${connector.auto_mapped}`}
              >
                {connector.auto_mapped ? connector.auto_mapped : '-'}
              </span>
            </div>
          ) : (
            ''
          )}
        </>
      ) : (
        ''
      )}
    </span>
  )

  if (connector.edited) {
    markedAs = <span className="text-red-600 pr-1"> &#9998; </span>
  } else if (connector.is_manual_mapped === '') {
    markedAs = ''
  } else if (connector.is_manual_mapped == true) {
    markedAs = <span className="text-red-600 pr-1"> A </span>
  } else {
    markedAs = <span className="text-red-600 pr-1"> M </span>
  }

  return (
    <div
      className={`flex flex-col items-center bg-white w-full border-b border-tracer-dark-blue group hover:bg-blue-100 `}
    >
      <div className="flex w-full font-bold group p-2 break-all">
        {markedAs} {connectorTitle}
      </div>
      <div
        className="object-left cursor-pointer text-blue-500 underline group-hover:block hidden font-normal w-full px-2"
        onClick={() => onClick(connector)}
      >
        {connector.auto_mapped ? 'Edit' : 'Select'}
      </div>
    </div>
  )
}

MappingItem.propTypes = {
  connector: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default MappingItem
